import React, { Component } from 'react';

import compose from 'recompose/compose';
import { DateRange } from 'react-date-range';

//import {es} from 'date-fns/locale';
import { es } from 'react-date-range/src/locale/index.js'
import { addDays, addMonths } from 'date-fns';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';

import PerfectScrollbar from 'react-perfect-scrollbar';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
// Shared components

import TextField from '@material-ui/core/TextField/index';
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import moment from 'moment'
import 'moment/locale/es'

import {createMaintenance} from '../../../services/createMaintenance'

// Component styles
import styles from './styles';
moment.locale('es')
class Schedule extends Component {
    constructor(props) {
        //console.log('props periodical', props.params.match.params.objetivo_id)
        const listObjectives=(JSON.parse(sessionStorage.getItem("listaObjetivosOnline")))
        const user=(sessionStorage.getItem("user"))
        const nameUser=(sessionStorage.getItem("user_name"))
        super(props);
        var range={
            selection: {
                startDate: new Date(),
                endDate: new Date(),
                key: 'selection',
                
                
            }
        }
        //this.myCallback = this.myCallback.bind(this);
        this.state = {
            props: props,
            online:null,
            dateRange:range,
            booleanDate:false,
            listObjectives:listObjectives,
            nameUser:nameUser,
            user:user,
            newState:{},
            errorBegin:false,
            errorFinal:false,
            error:false,
            errors:['No ha seleccionado Fecha o rango de Fecha', 'Falta Ingreso de Parametros', 
                    'Parametros de horario mal ingresado', 'Rango Horario mal Ingresado', 'Ingrese Objetivos',
                    'La fecha de fin no puede ser menor que la fecha de inicio'],
            loadModal:false,
            check:null
        }
    }

    handleRangeChange(which, payload) {
        this.setState({
            [which]: {
                ...this.state[which],
                ...payload,
            },
            booleanDate:true
        });
    
        
    }
    handleFieldChange = (field, value) => {
        const {dateRange, nameUser, booleanDate,newState}=this.state
        if(typeof(value)==='object'){
            field='objetivos'
        }
        if(field==='begin'){
            value='2020-01-01 '+String(value)
            if(String(moment(value)._f)!=="YYYY-MM-DD HH:mm:ss"){
                this.setState({
                    errorBegin:true
                })
            }else{
                value=moment(value, 'YYYY-MM-DD[T]HH:mm:ss')
                this.setState({
                    errorBegin:false
                })
            }
        }
        if(field==='final'){
            value='2020-01-01 '+String(value)
            if(String(moment(value)._f)!=="YYYY-MM-DD HH:mm:ss"){
                this.setState({
                    errorFinal:true
                })
            }else{
                this.setState({
                    errorFinal:false
                })
            }
        }else{
            this.setState({
                errorFinal:false
            })
        }
        newState[field] = value;
        if(Object.keys(newState).length===5){
            this.setState({
                newState:newState
            })
        }
    };

    handleSaved = async (value) => {
        const {dateRange, nameUser, booleanDate,newState, errorBegin, errorFinal, listObjectives, user}=this.state
        const {comment, titulo, objetivos}=newState
        var newObjetivos=(objetivos.map(ele=>ele.objetivo_id))

        if(booleanDate===false){
            this.setState({
                error:true,
                errorIndex:0
            })
        }
        else if(Object.keys(newState).length!==5){
            this.setState({
                error:true,
                errorIndex:1
            })
        }else{
            var begin=(moment(dateRange.selection.startDate).format("YYYY-MM-DD")+' '+moment(newState['begin']).format("HH:mm:ss"))
            var final=(moment(dateRange.selection.endDate).format("YYYY-MM-DD")+' '+moment(newState['final']).format("HH:mm:ss"))
            if(errorBegin===true || errorFinal===true){
                this.setState({
                    error:true,
                    errorIndex:2
                })
            }else if(moment(newState['begin']).unix()==moment(newState['final']).unix()){
                this.setState({
                    error:true,
                    errorIndex:3
                })
            }else if(newState['objetivos'].length===0){
                this.setState({
                    error:true,
                    errorIndex:4
                })
            }else if(begin > final){
                this.setState({
                    error:true,
                    errorIndex: 5
                })
            }else{
                let token = sessionStorage.getItem('key')
                //const {comment, titulo, objetivos}=newState
                //var begin=(moment(dateRange.selection.startDate).format("YYYY-MM-DD")+' '+moment(newState['begin']).format("HH:mm:ss"))
                //var final=(moment(dateRange.selection.endDate).format("YYYY-MM-DD")+' '+moment(newState['final']).format("HH:mm:ss"))
                
                /* llamo para hacer el insert si responde sale guardar si no que hubo error*/

                createMaintenance(user, nameUser, token, begin, final, comment, titulo, newObjetivos).then(data=>{
                    if(data===false){
                        this.setState({
                            loadModal: true,
                            check: false
                        });
                    }else{
                        this.setState({
                            loadModal: true,
                            check: true
                        }); 
                    }
                    
                })
            }
            
        }
    }

    handleClose = event => {
        //const newStep = event.currentTarget.id
        this.props.onInfo(0)
        this.setState({
            loadModal: false,
        })
    };

    render() {
        const {dateRange, booleanDate,nameUser, listObjectives, errorBegin, errorFinal, errorIndex, errors, error, loadModal, check}=this.state
        //console.log('period', this.props)
        return (
            <Portlet
            >
                <PortletHeader>
                <PortletLabel
                    subtitle="Ingrese mantenimiento"
                    title="Agenda"
                />
                </PortletHeader>
                <PortletContent noPadding>
                <form
                    autoComplete="off"
                    noValidate
                >
                    <Grid
                        container
                        style={{paddingLeft:"30px"}}
                    >
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            xl={12}
                            style={{textAlign:"left"}}                                   
                        >
                            <TextField
                                //helperText="Nombre"
                                label="Nombre"
                                margin="dense"
                                onChange={event =>
                                    this.handleFieldChange('name', event.target.value)
                                }
                                required
                                value={nameUser[0].toUpperCase() + nameUser.substring(1)}
                                disabled id="standard-disabled"
                                //variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            xl={12}                             
                        >
                            <Typography>Definir Rango de tiempo</Typography>
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            xl={6}                                
                        >
                            <DateRange
                                //maxDate={addDays(new Date(), 0)}
                                minDate={addMonths(new Date(), -3)}
                                locale={es}
                                onChange={this.handleRangeChange.bind(this, 'dateRange')}
                                moveRangeOnFirstSelection={false}
                                ranges={[this.state.dateRange.selection]}
                                className={'PreviewArea'}
                            />
                        </Grid>
                        {booleanDate?
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            xl={6}                                
                        >
                            
                            <Grid
                                container
                                spacing={1}
                                style={{textAlign:"left"}}    
                            >
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}                                
                                >
                                    <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}                                
                                    >
                                        <TextField
                                            //helperText="Nombre"
                                            label="hora inicio"
                                            margin="dense"
                                            required
                                            onChange={event =>
                                                this.handleFieldChange('begin', event.target.value)
                                            }
                                            placeholder="00:00:00"
                                            defaultValue=""
                                            //variant="outlined"
                                        />
                                    </Grid>
                                    {errorBegin?
                                        <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        xl={12}                                
                                        >
                                            <Typography variant="caption" color="primary">error de formato fecha</Typography>
                                        </Grid>
                                        :null
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}                                
                                >
                                    <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}                                
                                    >
                                    <TextField
                                        //helperText="23:59:59"
                                        label="hora termino"
                                        margin="dense"
                                        required
                                        onChange={event =>
                                            this.handleFieldChange('final', event.target.value)
                                        }
                                        placeholder="23:59:00"
                                        defaultValue=""
                                        //variant="outlined"
                                    />
                                    </Grid>
                                    {errorFinal?
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            xl={12}                                
                                            >
                                                <Typography variant="caption" color="primary">error de formato fecha</Typography>
                                        </Grid>
                                    :null}
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}                                
                                >
                                    <TextField
                                        //helperText="Nombre"
                                        label="titulo"
                                        margin="dense"
                                        required
                                        onChange={event =>
                                            this.handleFieldChange('titulo', event.target.value)
                                        }
                                        defaultValue=""
                                        //variant="outlined"
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}                                
                                >
                                    <TextField
                                        style={{width:"75%"}}
                                        id="standard-multiline-static"
                                        label="comentario"
                                        onChange={event =>
                                            this.handleFieldChange('comment', event.target.value)
                                        }
                                        multiline
                                        required
                                        rows={4}
                                        defaultValue=""
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}
                                >
                                    <Autocomplete
                    
                                        multiple
                                        id={option => option.objetivo_id}
                                        options={listObjectives}
                                        getOptionLabel={option => option.nombre}
                                        //onChange={this.changeFilter}
                                        onChange={this.handleFieldChange}
                                        renderInput={params => (
                                            <TextField
                                                //style={{color:params.color}}
                                                {...params}
                                                variant="standard"
                                                label="Selecciona Objetivos"
                                                placeholder="Objetivos"
                                                fullWidth
                                            />
                                            )}
                                        />
                                </Grid>
                                        
                            </Grid>
                            
                        </Grid>
                        :null}
                    </Grid>
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={loadModal}
                        onClose={this.handleClose}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            top:"150px"
                        }}
                        closeAfterTransition
                        //className={classes.tag0}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={loadModal}>
                            <PerfectScrollbar style={{position:"static"}}>
                            {check?
                            <Grid
                                container
                                spacing={1}
                                style={{paddingLeft:"30px", backgroundColor:"white", borderRadius:"18px"}}
                            >
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}                                  
                                >
                                    <Typography variant="h5" style={{color:"green", padding:"12px"}}>Mantenimiento Ingresado con exito</Typography>
                                </Grid>
                            </Grid>
                            :<div style={{backgroundColor:"white", width:"320px", height:"50px", textAlign:"center"}}>
                                <Typography variant="h5" style={{color:"red", padding:"12px"}}>Vuelva a Intentar a Ocurrido un error</Typography>
                            </div>
                            }
                            </PerfectScrollbar>
                        </Fade>
                    </Modal>
                </form>
                
                </PortletContent>
                <PortletFooter align="right" >
                    <Button
                        onClick={this.handleSaved}
                        color="primary"
                        variant="contained"
                    >
                        Guardar Mantenimiento
                    </Button>
                    {error?
                        <Typography variant="caption" color="primary">{errors[errorIndex]}</Typography>
                    :null}
                    
                </PortletFooter>
            </Portlet>
            
        );
    }
}


export default compose(withWidth(), withStyles(styles))(Schedule);
